import { CardMedia, CardMediaProps } from "@mui/material";
import useImageSize from "../../../hooks/global/useImageSize";

type BlogCardImageProps = CardMediaProps;

export const BlogCardImage = ({
  image,
  title,
  ...props
}: BlogCardImageProps) => {
  const [imageUrl] = useImageSize({
    imageUrl: image,
    size: 1000,
    isCover: true,
  });

  return (
    <CardMedia
      component={"img"}
      height={"268"}
      width={"328"}
      image={imageUrl}
      alt={title}
      title={title}
      sx={{
        borderRadius: "1.25rem",
      }}
      {...props}
    />
  );
};
